import { render, staticRenderFns } from "./UpgradeFeaturePayment.vue?vue&type=template&id=46634676&scoped=true"
import script from "./UpgradeFeaturePayment.vue?vue&type=script&lang=js"
export * from "./UpgradeFeaturePayment.vue?vue&type=script&lang=js"
import style0 from "./UpgradeFeaturePayment.vue?vue&type=style&index=0&id=46634676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46634676",
  null
  
)

export default component.exports